import { SelectOption } from '../classes'
import { Notification } from '../model/notification'

export const NotificationTypes: SelectOption<string>[] = [
  // { value: Notification.TYPE.EB, viewValue: 'E&B' }, // we do not appear to use this
  {
    value: Notification.TYPE.DISPUTES,
    viewValue: 'profile.tab.notifications.types.disputes',
  },
  {
    value: Notification.TYPE.INCORRECT_DOB,
    viewValue: 'profile.tab.notifications.types.incorrect-dob',
  },
  {
    value: Notification.TYPE.INCORRECT_MEMBER_ID,
    viewValue: 'profile.tab.notifications.types.incorrect-insurance',
  },
  {
    value: Notification.TYPE.INCORRECT_PATIENT_NAME,
    viewValue: 'profile.tab.notifications.types.incorrect-patient-name',
  },
  {
    value: Notification.TYPE.INCORRECT_PHONE_NUMBER,
    viewValue: 'profile.tab.notifications.types.incorrect-phone',
  },
  {
    value: Notification.TYPE.INCORRECT_EMAIL,
    viewValue: 'profile.tab.notifications.types.incorrect-email',
  },
  {
    value: Notification.TYPE.INTAKE_SUBMITTED,
    viewValue: 'profile.tab.notifications.types.intake-submitted',
  },
  {
    value: Notification.TYPE.MESSAGES,
    viewValue: 'profile.tab.notifications.types.received-message',
  },
  {
    value: Notification.TYPE.NEGATIVE_APPOINTMENT_CONFIRMATION,
    viewValue: 'profile.tab.notifications.types.patient-rejected',
  },
  {
    value: Notification.TYPE.PAYMENTS,
    viewValue: 'profile.tab.notifications.types.payments',
  },
  {
    value: Notification.TYPE.WORKFLOW,
    viewValue: 'profile.tab.notifications.types.workflow',
  },
  {
    value: Notification.TYPE.PATIENT_MISSING_FROM_EMR,
    viewValue: 'profile.tab.notifications.types.patient-missing',
  },
]
